import {
  getScrollSmoother,
  isNewsRoute,
  readNewsScrollPosition,
  setScrollPosition,
} from '@lib/tools/scroll/scrollPosition';

export const handleBodyUnlock = () => {
  if (!Object.hasOwn(document.body.dataset, 'bodyScrollFix')) return;

  let scrollPosition = Number(document.body.dataset.bodyScrollFix);
  delete document.body.dataset.bodyScrollFix;

  if (isNewsRoute(window.location.pathname)) {
    const stored = readNewsScrollPosition();
    if (Number.isFinite(stored)) {
      scrollPosition = stored;
    }
  }

  const smoother = getScrollSmoother();

  if (smoother) {
    const wrapper = document.getElementById('smooth-wrapper');
    if (wrapper) wrapper.style.overflow = '';
    smoother.paused(false);
    setScrollPosition(scrollPosition);
    return;
  }

  document.body.style.overflow = '';
  document.body.style.position = '';
  document.body.style.top = '';
  document.body.style.left = '';
  document.body.style.width = '';
  setScrollPosition(scrollPosition);
};
